import { useEffect } from 'react';

export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  // Some modals put their own Close button in the body/footer (e.g. the
  // Entra reminder after adding a team member). Setting this to true
  // suppresses the header Close so the user doesn't see two identical
  // buttons stacked on the same screen. Backdrop click + Escape key
  // still close the modal regardless.
  hideHeaderClose = false,
  // Header close-button label. Defaults to "Cancel" — the X-equivalent
  // that dismisses the modal without saving. Read-only or non-form
  // modals can pass a different label (e.g. `closeLabel="Close"`).
  closeLabel = 'Cancel',
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: 16 }}>{title}</h2>
          {!hideHeaderClose && (
            <button className="btn btn-outline btn-sm" onClick={onClose}>
              {closeLabel}
            </button>
          )}
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
